import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';
import ExerciseIcon from '@pelckmans/elementis/icons/exercise';
import { useContext } from 'react';
import ModuleContext from '../../_contexts/ModuleContext';
import AvatarIcon from '@pelckmans/elementis/components/avatar/avatar-icon';
import { useTranslation } from 'react-i18next';
import { useRoutes } from '../../../../hooks/useRoutes';

export default function VirtualExerciseModuleBreadcrumb() {
  const { module } = useContext(ModuleContext);
  const { t } = useTranslation();
  const { buildAbsolutePath } = useRoutes();

  if (!module) return null;

  const params = {
    subjectSlug: module.subjectSlug,
    methodSlug: module.methodSlug,
    moduleSlug: module.slug,
  };

  return (
    <Breadcrumbs.Item
      avatarIcon={<AvatarIcon icon={<ExerciseIcon />} />}
      to={buildAbsolutePath(['MATERIAL', 'MATERIAL.CONTENT', 'MATERIAL.VEM'], params)}
    >
      {t('MODULES.VIRTUAL_EXERCISE_MODULE')}
    </Breadcrumbs.Item>
  );
}
